import { Stack, useRouter } from 'expo-router';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { useBackHandler } from 'shared/hooks/useBackHandler/useBackHandler';
import useDismissToRootTab, {
  Tabs,
} from 'shared/hooks/useDismissToRootTab/useDismissToRootTab';
import ErrorScreen, {
  ErrorScreenType,
} from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import theme from 'shared/styles/theme';

const SetUpError = () => {
  const router = useRouter();
  const { t: translatedText } = useTranslation('payLater', {
    keyPrefix: 'setUpError',
  });
  const dismissToTab = useDismissToRootTab();

  const goHome = () => {
    dismissToTab(Tabs.HOME);
  };

  const handleTryAgainPress = () => {
    if (router.canGoBack()) {
      router.back();
    } else {
      router.replace('/pay-later');
    }
  };

  useBackHandler(goHome);

  return (
    <View style={styles.screen}>
      <Stack.Screen options={{ headerShown: false, gestureEnabled: false }} />
      <ErrorScreen
        screenType={ErrorScreenType.Error}
        messageHeadline={translatedText('title')}
        messageBody={translatedText('body')}
        primaryButton={{
          title: translatedText('tryAgain'),
          onPress: handleTryAgainPress,
        }}
        secondaryButton={{
          title: translatedText('done'),
          onPress: goHome,
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  screen: { backgroundColor: theme.color.background.primary, flex: 1 },
});

export default SetUpError;
